var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.rowSpacing},[_c('CheckboxWithLabel',{attrs:{"disabled":!_vm.isSambaAuthenticationEnabled,"label":"Enable Samba Authentication","preventDefault":true,"tooltip":_vm.$options.tooltip,"value":_vm.sambaEnabled},on:{"change":_vm.handleSambaAuthenticationChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }